import { useState } from 'react';
import { MobileSheet, Stack, Row, Text, Button } from '../ui';
import { api } from '../api/client';

export function ReconcileModal({ payment, open, onClose, onSuccess }: { payment: any; open: boolean; onClose: () => void; onSuccess: () => void }) {
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function confirm() {
    setBusy(true); setErr('');
    try { await api.reconcilePayment(payment.id, { notes: notes.trim() || undefined }); onSuccess(); onClose(); setNotes(''); }
    catch (e: any) { setErr(e.message ?? 'failed'); } finally { setBusy(false); }
  }

  if (!payment) return null;
  const amt = payment.amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <MobileSheet open={open} onClose={onClose} title="Reconcile Payment">
      <Stack gap={3}>
        <div>
          <Text variant="small" className="font-medium">{payment.dealName ?? 'Deal'}</Text>
          <Text variant="label" muted>{payment.direction} · {payment.currency} {amt}</Text>
          {payment.referenceNumber && <Text variant="label" muted>ref: {payment.referenceNumber}</Text>}
        </div>
        <Stack gap={0.5}>
          <Text variant="micro">notes (optional)</Text>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="reconciliation notes..." rows={3} className="hairline rounded-sm px-2 py-2 bg-bg text-sm w-full resize-none" />
        </Stack>
        <Text variant="small" muted>Mark this payment as reconciled? This confirms the funds have been verified against your records.</Text>
        {err && <Text variant="small" className="text-negative">{err}</Text>}
        <Row gap={2} justify="end">
          <Button variant="ghost" onClick={onClose}>cancel</Button>
          <Button variant="primary" onClick={confirm} disabled={busy}>{busy ? 'reconciling...' : 'confirm reconciled'}</Button>
        </Row>
      </Stack>
    </MobileSheet>
  );
}
